var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkBuildAnything = function SvgMarkBuildAnything(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFD8D8",
    strokeOpacity: 0.2,
    strokeWidth: 0.75,
    d: "M58.625 44.625h11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFD8D8",
    strokeDasharray: "1.5 1.5",
    strokeOpacity: 0.2,
    strokeWidth: 0.75,
    d: "M45.25 18.375V11M74.5 44.625h11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD8D8",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M31.875 45h-11v-.75h11z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFD8D8",
    strokeDasharray: "1.5 1.5",
    strokeOpacity: 0.2,
    strokeWidth: 0.75,
    d: "M45.25 78.25v-7.375M5 44.625h11"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.25,
    cy: 44.625,
    r: 19.5,
    stroke: "#FFD8D8",
    strokeOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.25,
    cy: 44.625,
    r: 23.875,
    stroke: "#FFD8D8",
    strokeOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.25,
    cy: 44.625,
    r: 31.125,
    stroke: "#FFD8D8",
    strokeOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD8D8",
    fillRule: "evenodd",
    d: "M51 45H40v-1h11z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD8D8",
    fillRule: "evenodd",
    d: "M46 39v11h-1V39z",
    clipRule: "evenodd"
  })));
};
export { SvgMarkBuildAnything as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTAiIGhlaWdodD0iOTAiIHZpZXdCb3g9IjAgMCA5MCA5MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTU4LjYyNSA0NC42MjVINjkuNjI1IiBzdHJva2U9IiNGRkQ4RDgiIHN0cm9rZS1vcGFjaXR5PSIwLjIiIHN0cm9rZS13aWR0aD0iMC43NSIvPgo8cGF0aCBkPSJNNDUuMjUgMTguMzc1TDQ1LjI1IDExIiBzdHJva2U9IiNGRkQ4RDgiIHN0cm9rZS1vcGFjaXR5PSIwLjIiIHN0cm9rZS13aWR0aD0iMC43NSIgc3Ryb2tlLWRhc2hhcnJheT0iMS41IDEuNSIvPgo8cGF0aCBkPSJNNzQuNSA0NC42MjVMODUuNSA0NC42MjUiIHN0cm9rZT0iI0ZGRDhEOCIgc3Ryb2tlLW9wYWNpdHk9IjAuMiIgc3Ryb2tlLXdpZHRoPSIwLjc1IiBzdHJva2UtZGFzaGFycmF5PSIxLjUgMS41Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMzEuODc1IDQ1SDIwLjg3NVY0NC4yNUgzMS44NzVWNDVaIiBmaWxsPSIjRkZEOEQ4IiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNNDUuMjUgNzguMjVMNDUuMjUgNzAuODc1IiBzdHJva2U9IiNGRkQ4RDgiIHN0cm9rZS1vcGFjaXR5PSIwLjIiIHN0cm9rZS13aWR0aD0iMC43NSIgc3Ryb2tlLWRhc2hhcnJheT0iMS41IDEuNSIvPgo8cGF0aCBkPSJNNSA0NC42MjVMMTYgNDQuNjI1IiBzdHJva2U9IiNGRkQ4RDgiIHN0cm9rZS1vcGFjaXR5PSIwLjIiIHN0cm9rZS13aWR0aD0iMC43NSIgc3Ryb2tlLWRhc2hhcnJheT0iMS41IDEuNSIvPgo8Y2lyY2xlIGN4PSI0NS4yNSIgY3k9IjQ0LjYyNSIgcj0iMTkuNSIgc3Ryb2tlPSIjRkZEOEQ4IiBzdHJva2Utb3BhY2l0eT0iMC4yIi8+CjxjaXJjbGUgY3g9IjQ1LjI1IiBjeT0iNDQuNjI1IiByPSIyMy44NzUiIHN0cm9rZT0iI0ZGRDhEOCIgc3Ryb2tlLW9wYWNpdHk9IjAuMiIvPgo8Y2lyY2xlIGN4PSI0NS4yNSIgY3k9IjQ0LjYyNSIgcj0iMzEuMTI1IiBzdHJva2U9IiNGRkQ4RDgiIHN0cm9rZS1vcGFjaXR5PSIwLjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01MSA0NUg0MFY0NEg1MVY0NVoiIGZpbGw9IiNGRkQ4RDgiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00NiAzOUw0NiA1MEw0NSA1MEw0NSAzOUw0NiAzOVoiIGZpbGw9IiNGRkQ4RDgiLz4KPC9zdmc+Cg==";